import { render, staticRenderFns } from "./context_menu.vue?vue&type=template&id=0a53c74e&scoped=true&"
import script from "./context_menu.vue?vue&type=script&lang=js&"
export * from "./context_menu.vue?vue&type=script&lang=js&"
import style0 from "./context_menu.vue?vue&type=style&index=0&id=0a53c74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a53c74e",
  null
  
)

export default component.exports